// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3k_eo","rootCenter":"LoadMoreObserver_rootCenter__GwLl7","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__28NP3"};